import { Component, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { DateTime } from "luxon";
import { MenuConstants } from "../../infrastructure/MenuConstants";
import {
  TicketStatus,
  TicketType,
  WorkflowStatus,
} from "../../model/domain/Entity";
import { FilterDateType } from "../../model/domain/MonitorFilter";
import { ElectronicTransferSummary } from "../../model/ElectronicTransferSummary";
import { TicketMonitorStatus } from "../../model/StatusBoleta";
import { LoaderService } from "../../services/loader.service";
import { TicketService } from "../../services/ticket.service";
import { TransferService } from "../../services/tickets/Transfer.service";

@Component({
  selector: "app-monitor-geral",
  templateUrl: "./monitor-geral.component.html",
  styleUrls: ["./monitor-geral.component.scss"],
})
export class MonitorGeralComponent implements OnInit, OnDestroy {
  statusList: TicketMonitorStatus[] = [];
  statusListCancel: TicketMonitorStatus[] = [];
  TicketType = TicketType;
  interval: NodeJS.Timer = null;

  transferStatusList: ElectronicTransferSummary[];

  columns = [
    "Status",
    "Quota",
    "CETIP",
    "SELIC",
    "Futures",
    "Margin",
    "Contracted",
    "CurrencyTerm",
    "VariableIncome",
    "SwapCetip",
    "Exchange",
    "Loan",
    "Transfer",
    "Expenses",
    "Liabilities",
    "StructuredOperations",
    "StructuredOperationOrder",
  ];

  transferColumns = ["Status", "Count"];

  statusMappings = {
    [TicketStatus.Draft]: "Em Elaboração",
  };

  constructor(
    private ticketService: TicketService,
    private router: Router,
    private loaderService: LoaderService,
    private transferService: TransferService
  ) {}

  ngOnInit() {
    this.getStatus();
    this.getTransfersStatus();
    this.setTimer();
  }

  ngOnDestroy() {
    clearInterval(this.interval as any);
  }

  goTo(ticketId: number = null, statusId: number = null) {
    const params: any = {};

    if (ticketId) {
      params.ticketType = ticketId;
    }

    if (statusId) {
      params.statusId = statusId;
    }

    params.dateType = FilterDateType.SettlementDate;

    this.router.navigate([MenuConstants.Todos], { queryParams: params });
  }

  getStatus(): void {
    this.ticketService.getWorkflowStatus().subscribe(
      (status) => {
        this.statusMappings = Object.assign(this.statusMappings, status);
      },
      () => {},
      () => this.getSummary()
    );
  }

  getTransfersStatus(): void {
    this.transferService.getTransfersSummary().subscribe((status) => {
      this.transferStatusList = status;
    });
  }

  getSummary(): void {
    this.loaderService.addLoader();

    // TODO: criar dicionário para estes valores
    const ticketMappings = {
      [TicketType.Quota]: "Quota",
      [TicketType.CETIP]: "CETIP",
      [TicketType.SELIC]: "SELIC",
      [TicketType.Contracted]: "Contracted",
      [TicketType.Futures]: "Futures",
      [TicketType.SwapCetip]: "SwapCetip",
      [TicketType.VariableIncome]: "VariableIncome",
      [TicketType.CurrencyTerm]: "CurrencyTerm",
      [TicketType.Margin]: "Margin",
      [TicketType.Exchange]: "Exchange",
      [TicketType.Loan]: "Loan",
      [TicketType.Transfer]: "Transfer",
      [TicketType.Expenses]: "Expenses",
      [TicketType.Liabilities]: "Liabilities",
      [TicketType.StructuredOperations]: "StructuredOperations",
      [TicketType.StructuredOperationOrder]: "StructuredOperationOrder",
    };

    this.ticketService
      .summary(DateTime.local().toJSDate(), DateTime.local().toJSDate())
      .subscribe(
        (data) => {
          const newData = data
            .sort((a, b) => {
              if ((a.statusId || 0) >= (b.statusId || 0)) {
                return 1;
              }
              if ((a.statusId || 0) < (b.statusId || 0)) {
                return -1;
              }
            })
            .map((d) => {
              const id = d.statusId || -1;
              const newRow: TicketMonitorStatus = {
                Status: {
                  Id: id,
                  Description: this.statusMappings[id],
                },
                Quota: 0,
                CETIP: 0,
                SELIC: 0,
                Contracted: 0,
                CurrencyTerm: 0,
                VariableIncome: 0,
                SwapCetip: 0,
                Margin: 0,
                Futures: 0,
                Loan: 0,
                Exchange: 0,
                Transfer: 0,
                Expenses: 0,
                Liabilities: 0,
                StructuredOperations: 0,
                StructuredOperationOrder: 0,
              };

              (d.tickets || []).forEach((t: any) => {
                newRow[ticketMappings[t.ticketTypeId]] = t.count;
              });

              return newRow;
            });

          var cancelledStatusList = [
            WorkflowStatus.CancelledByAdm,
            WorkflowStatus.CancelledBySettlement,
            WorkflowStatus.CancelledByDetainer,
            WorkflowStatus.CancelledByMiddle,
            WorkflowStatus.CancelledByAccountManager,
            WorkflowStatus.CancelledBySantander,
            WorkflowStatus.CancelledByDistribution,
            WorkflowStatus.CancelledBySettlementPilot,
            WorkflowStatus.CancelledByPassive,
            WorkflowStatus.UploadCancelled,
            WorkflowStatus.StructuredCancelledInPreAnalysis,
            WorkflowStatus.StructuredCancelledInAnalysis,
            WorkflowStatus.StructuredCancelledInReservationAnalysis,
            WorkflowStatus.CancelledByControllership,
          ];

          this.statusList = newData.filter(
            (data) => cancelledStatusList.indexOf(data.Status.Id) == -1
          );

          this.statusListCancel = newData.filter(
            (data) => cancelledStatusList.indexOf(data.Status.Id) == 1
          );
        },
        () => {}
      );

    this.loaderService.removeLoader();
  }

  setTimer() {
    this.interval = setInterval(() => {
      this.getStatus();
    }, 5 * 60 * 1000);
  }
}
